import React, { useState, useCallback } from 'react';
import Dropzone from 'react-dropzone';
import uploadFileApi from '../../../utils/FileService';
import Colors from '../../../utils/Colors';
import Progress from '../../ui/LoadingComponent/Progress';
import ImagePlusIcon from '../../../assets/icons/ImagePlusIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon';
import './styles.css';

const FileUpload = ({
                        windowSize,
                        progressSize,
                        image,
                        style = {},
                        imgSize,
                        svgSize,
                        handleDelete,
                        handleChange,
                        client,
                        uploadOnSelect = true,
                    }) => {
    const [uploadPercent, setUploadPercent] = useState(0);
    const [uploadingIcon, setUploadingIcon] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const onUploadProgress = useCallback((progressEvent) => {
        const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadPercent(percent);
    }, []);

    const uploadFiles = useCallback(
        (files) => {
            const file = files[0];
            if (!file) return;

            if (!uploadOnSelect) {
                client ? handleChange(client, file) : handleChange(file);
                setIsHovered(false);
                return;
            }

            const data = new FormData();
            data.append('file', file);

            const uploadConfig = { onUploadProgress };
            setUploadingIcon(true);

            uploadFileApi(data, uploadConfig)
                .then((link) => {
                    client ? handleChange(client, link) : handleChange(link);
                })
                .finally(() => {
                    setUploadingIcon(false);
                    setUploadPercent(0);
                });

            setIsHovered(false);
        },
        [client, handleChange, uploadOnSelect, onUploadProgress]
    );

    return (
        <div
            className="centered-flex-container"
            style={{
                flexBasis: `${windowSize}px`,
                overflow: 'hidden',
                position: 'relative',
                ...style,
            }}
        >
            {uploadingIcon ? (
                <Progress size={progressSize} percent={uploadPercent} strokeWidth={2} />
            ) : (
                <Dropzone
                    disabled={!!(image && handleDelete)}
                    onDrop={uploadFiles}
                    style={{
                        width: `${windowSize}px`,
                        height: `${windowSize}px`,
                        cursor: 'pointer',
                        position: 'relative',
                        flexShrink: 0,
                    }}
                    className="centered-flex-container"
                >
                    <div
                        className="file-upload-container"
                        style={{
                            width: windowSize,
                            height: windowSize,
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        {image ? (
                            <React.Fragment>
                                <img
                                    src={image}
                                    width={imgSize}
                                    height={imgSize}
                                    style={{
                                        borderRadius: '50%',
                                        flexShrink: 0,
                                        objectFit: 'cover',
                                    }}
                                    alt="uploaded"
                                />

                                {handleDelete && (
                                    <div
                                        className={`delete-overlay ${isHovered ? 'show' : ''}`}
                                        onClick={handleDelete}
                                        style={{
                                            width: imgSize,
                                            height: imgSize,
                                        }}
                                    >
                                        <DeleteIcon
                                            stroke="white"
                                            width={svgSize || imgSize / 2}
                                            height={svgSize || imgSize / 2}
                                            className={`delete-icon ${isHovered ? 'visible' : ''}`}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        ) : (
                            <ImagePlusIcon
                                style={{color: Colors.silverBlueLite}} stroke="currentColor"
                                width={svgSize || imgSize}
                                height={svgSize || imgSize}
                            />
                        )}
                    </div>
                </Dropzone>
            )}
        </div>
    );
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components-new/general/FileUpload/index.jsx